import { useQuery } from "@tanstack/react-query";
import { LoaderCircle } from "lucide-react";
import { Dashboard } from "./components/Dashboard";
import { SignIn } from "./components/SignIn";
import { ApiRequestError, api } from "./lib/api";

function authReason(): "denied" | "error" | "invalid" | null {
  const value = new URLSearchParams(window.location.search).get("auth");
  return value === "denied" || value === "error" || value === "invalid" ? value : null;
}

function isAuthenticationError(error: unknown): boolean {
  return error instanceof ApiRequestError && (error.status === 401 || error.status === 403);
}

export function App() {
  const sessionQuery = useQuery({
    queryKey: ["session"],
    queryFn: api.getSession,
    retry: false,
  });

  if (sessionQuery.isPending) {
    return (
      <main className="boot-screen">
        <span className="boot-screen__mark" aria-hidden="true">
          <LoaderCircle size={24} />
        </span>
        <strong>Opening the relay</strong>
        <span>Checking the management session…</span>
      </main>
    );
  }

  if (sessionQuery.error && isAuthenticationError(sessionQuery.error)) {
    return <SignIn reason={authReason()} />;
  }

  if (sessionQuery.error || !sessionQuery.data) {
    return (
      <main className="boot-screen boot-screen--error">
        <strong>The relay API is unavailable.</strong>
        <span>{sessionQuery.error?.message ?? "Try again in a moment."}</span>
        <button
          className="button button--ghost"
          type="button"
          onClick={() => sessionQuery.refetch()}
        >
          Retry connection
        </button>
      </main>
    );
  }

  return <Dashboard session={sessionQuery.data} />;
}
